import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  /** Classes de mise en page laissées à l'hôte (largeur, marges). */
  className?: string;
  testId?: string;
}

/**
 * Le rappel « il vous manque X € pour … ».
 *
 * Rouge plein et NON thémable : c'est le seul bloc du panier qui doit rester
 * identique d'un restaurant à l'autre. En 12px rose sur crème il se lisait
 * comme une note de bas de page, juste au-dessus du bouton — le client passait
 * à côté de la remise sans jamais la voir. `--sale-red` est déjà le rouge des
 * promotions du menu (PromoBand), pas une des 6 couleurs de `RestaurantTheme` :
 * un thème clair ou pastel ne peut pas le diluer.
 */
export default function UpsellBanner({ children, className = '', testId }: Props) {
  return (
    <div
      role="status"
      data-testid={testId}
      className={`flex items-center gap-2 border-2 border-ink rounded-btn px-3 py-2 font-display text-sm leading-snug text-white shadow-stamp-sm ${className}`}
      style={{ background: 'var(--sale-red)' }}
    >
      {children}
    </div>
  );
}
